import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";

export class FormatThumbnailSource extends AbstractSource {
  constructor(getToken: () => string, public id: number) {
    super(getToken);
    if (id === undefined) {
      throw new Error("id is empty!!!");
    }
  }

  protected getSource(): string {
    // TODO:キャッシュするならここで実装する.とりあえずはソース文字列を返す.
    const url = "/api/Format/" + this.id + "/Thumbnail?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new FormatThumbnailSource(
      this._getToken,
      this.id
    );
  }

}
